import { BrandButton } from '@/components/ui/brand-button';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';

export default function UnauthorizedPage() {
  return (
    <main className="flex flex-1 items-center justify-center px-6 py-12">
      <Card className="animate-in fade-in zoom-in-95 relative w-full max-w-3xl border-none bg-white p-12 shadow-2xl duration-200">
        <div className="flex flex-col items-center space-y-8">
          <h1 className="text-4xl font-bold text-red-600">403</h1>
          <h2 className="mt-2 text-2xl font-semibold text-gray-900">
            Unauthorized Access
          </h2>
        </div>
      </Card>
      <BrandButton className="mt-6">
        <Link to="/">Go back home</Link>
      </BrandButton>
    </main>
  );
}
